export const imports = {
  'src/components/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-index" */ 'src/components/index.mdx'
    ),
  'src/components/Button/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-button-index" */ 'src/components/Button/index.mdx'
    ),
  'src/components/Alert/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-alert-index" */ 'src/components/Alert/index.mdx'
    ),
  'src/components/Desc/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-desc-index" */ 'src/components/Desc/index.mdx'
    ),
}
